import slider1 from '../images/sliders/sliderOne.jpg';
import slider2 from '../images/sliders/sliderTwo.png';
import slider3 from '../images/sliders/sliderThree.png';
import slider4 from '../images/sliders/sliderFour.png';

export const allSliders = [
  {
    id: 1,
    image: slider1,
    title1: 'Proven Track Record',
    desc:
      'Rooftop solar journey began in 2005 and developed country’s first OpEx project. Designed and installed a number of projects covering multiple sectors including RMG, Textile, FMCG, Agro and Paper Mills.',
  },
  {
    id: 2,
    image: slider2,
    title1: 'Engineered the World’s Largest',
    title2: 'Rooftop 40 MWp Solar Project',
    desc:
      'The project is being installed at the KEPZ in Chattogram, Bangladesh with the EPC service from SOLARIC.  Once completed, the entire KEPZ will be credited with RE100 certification for its achievement of “Net Zero” emission.',
  },
  {
    id: 3,
    image: slider3,
    title1: 'Largest Producer of',
    title2: 'Rooftop Solar Energy',
    desc:
      'A cumulative total capacity of 20 MWp of rooftop solar system is in operation already with a pipeline of 100 MWp  Generating 30 GWh of of green energy per year making the company the country’s largest rooftop solar energy producer. ',
  },
  {
    id: 4,
    image: slider4,
    title1: 'R&D Driven',
    title2: 'Solar Focused company',
    desc:
      'Country’s only R&D driven solar focused and vertically integrated company offering innovative solution with world class engineering customized to the factory need.',
  },
];
